import React from 'react';
import Modal from '../common/Modal';
import { availableWallets, isMobile, buildTrustDeepLink, buildMetaMaskDeepLink } from '../../utils/walletDetect';
import { useWallet } from '../../context/WalletContext';

const FALLBACK = [
  { id: 'trust',    name: 'Trust Wallet',    icon: 'TW', deep: buildTrustDeepLink },
  { id: 'metamask', name: 'MetaMask',        icon: 'MM', deep: buildMetaMaskDeepLink }
];

const WalletModal = ({ open, onClose }) => {
  const { connect, connecting } = useWallet();
  const list = availableWallets();

  const onPick = async (id) => {
    await connect(id);
    onClose && onClose();
  };

  const onMobileFallback = (deepFn) => {
    const url = deepFn();
    if (url) window.location.href = url;
  };

  return (
    <Modal open={open} onClose={onClose} title="Connect Wallet" maxWidth={460}>
      {list.length > 0 ? (
        <>
          <div style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 8 }}>
            Choose a detected wallet
          </div>
          <div className="wallet-grid">
            {list.map((w) => (
              <button
                key={w.id}
                className="wallet-option"
                disabled={connecting}
                onClick={() => onPick(w.id)}
              >
                <div className="icon">{w.icon}</div>
                <div>
                  <div className="name">{w.name}</div>
                  <div className="hint">Detected</div>
                </div>
              </button>
            ))}
          </div>
        </>
      ) : isMobile() ? (
        <>
          <div style={{ color: 'var(--text-muted)', fontSize: 13, marginBottom: 8 }}>
            No wallet detected. Open in your wallet app:
          </div>
          <div className="wallet-grid">
            {FALLBACK.map((w) => (
              <button
                key={w.id}
                className="wallet-option"
                onClick={() => onMobileFallback(w.deep)}
              >
                <div className="icon">{w.icon}</div>
                <div>
                  <div className="name">Open in {w.name}</div>
                  <div className="hint">Mobile deep-link</div>
                </div>
              </button>
            ))}
          </div>
        </>
      ) : (
        <div className="empty">
          <div className="empty-icon">⌧</div>
          <div className="empty-title">No wallet detected</div>
          <div>Install Trust Wallet, MetaMask, or another web3 wallet to continue.</div>
        </div>
      )}
    </Modal>
  );
};

export default WalletModal;
